<template>
  <div>
    <div v-if="loading" class="text-center py-4">
      <mainLoader />
    </div>
    <div v-else>
      <successAlert v-if="success" message="تم حفظ البيانات الإضافية بنجاح" />
      <errorAlert v-if="error" :alertMessage="errorMessage" />

      <form @submit.prevent="save">
        <div class="row">
          <div class="col">
            <div class="form-head"><i class="bi bi-chevron-left"></i> بيانات المياه:</div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label class="form-label">فصل وحدات الماء</label>
            <select class="form-control" v-model="form.waterSeparation">
              <option :value="null">غير محدد</option>
              <option :value="true">نعم</option>
              <option :value="false">لا</option>
            </select>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label class="form-label">رقم حساب الماء</label>
            <input type="text" class="form-control" v-model="form.waterAccountNumber" placeholder="اختياري" />
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label class="form-label">رقم عداد الماء</label>
            <input type="text" class="form-control" v-model="form.waterMeterNumber" placeholder="اختياري" />
          </div>
        </div>

        <div class="row">
          <div class="col">
            <div class="form-head"><i class="bi bi-chevron-left"></i> اللوحة الإعلانية:</div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label class="form-label">رقم اللوحة الإعلانية</label>
            <input type="text" class="form-control" v-model="form.billboardNumber" placeholder="اختياري" />
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label class="form-label">
              رقم الحارس
              <span class="req">*</span>
            </label>
            <input type="text" class="form-control" v-model="form.guardNumber" placeholder="مطلوب لإنشاء طلب لوحة" />
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label class="form-label">
              مدير المشروع المسؤول عن التعميد
              <span class="req">*</span>
            </label>
            <select class="form-control" v-model="form.projectManagerId">
              <option :value="null">اختر مدير المشروع</option>
              <option v-for="admin in approvalManagers" :key="admin.id" :value="admin.id">
                {{ admin.name }}
              </option>
            </select>
            <small class="text-muted">تظهر هنا حسابات مسؤولي التعميد الفعّالة فقط.</small>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <div class="form-head"><i class="bi bi-chevron-left"></i> بيانات الكهرباء:</div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label class="form-label">رقم حساب الكهرباء</label>
            <input type="text" class="form-control" v-model="form.electricityAccountNumber" placeholder="اختياري" />
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label class="form-label">رقم حساب عداد الكهرباء للمستأجر</label>
            <input type="text" class="form-control" v-model="form.electricityTenantMeterAccount" placeholder="اختياري" />
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label class="form-label">رقم العداد</label>
            <input type="text" class="form-control" v-model="form.electricityMeterNumber" placeholder="اختياري" />
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label class="form-label">رقم اشتراك العداد</label>
            <input type="text" class="form-control" v-model="form.electricityMeterSubscription" placeholder="اختياري" />
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label class="form-label">رقم موقع عداد الكهرباء</label>
            <input type="text" class="form-control" v-model="form.electricityMeterLocationNumber" placeholder="اختياري" />
          </div>
        </div>

        <div class="row">
          <div class="col">
            <div class="form-head"><i class="bi bi-chevron-left"></i> الكراج:</div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label class="form-label">عدد الكراج</label>
            <input type="number" min="0" class="form-control" v-model.number="form.garageCount" placeholder="اختياري" />
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label class="form-label">عدد ريموتات الكراج</label>
            <input type="number" min="0" class="form-control" v-model.number="form.garageRemoteCount" placeholder="اختياري" />
          </div>
        </div>

        <div class="row">
          <div class="col">
            <div class="form-head"><i class="bi bi-chevron-left"></i> المكيفات:</div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label class="form-label">عدد المكيفات</label>
            <input type="number" min="0" class="form-control" v-model.number="form.acCount" placeholder="اختياري" />
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label class="form-label">عدد ريموتات المكيفات</label>
            <input type="number" min="0" class="form-control" v-model.number="form.acRemoteCount" placeholder="اختياري" />
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label class="form-label">نوع المكيف</label>
            <input type="text" class="form-control" v-model="form.acType" placeholder="اختياري" />
          </div>
        </div>

        <div class="row">
          <div class="col">
            <div class="form-head"><i class="bi bi-chevron-left"></i> المطابخ والسخانات:</div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label class="form-label">عدد المطابخ</label>
            <input type="number" min="0" class="form-control" v-model.number="form.kitchenCount" placeholder="اختياري" />
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label class="form-label">عدد السخانات</label>
            <input type="number" min="0" class="form-control" v-model.number="form.heaterCount" placeholder="اختياري" />
          </div>
        </div>

        <div class="row">
          <div class="col">
            <div class="form-head"><i class="bi bi-chevron-left"></i> عقد الهيئة العامة للعقار:</div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label class="form-label">رقم عقد الهيئة العامة للعقار</label>
            <input type="text" class="form-control" v-model="form.regaContractNumber" placeholder="اختياري" />
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label class="form-label">تاريخ تجديد العقد الإلكتروني</label>
            <input type="date" class="form-control" v-model="form.regaContractRenewalDate" />
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label class="form-label">تاريخ تجديد عقد إدارة الأملاك</label>
            <input type="date" class="form-control" v-model="form.managementContractRenewalDate" />
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-head"><i class="bi bi-chevron-left"></i> ميزة العائد الاستثماري:</div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 mb-3">
            <div v-if="form.roiReportPath" class="d-flex align-items-center gap-3 p-2 border rounded">
              <i class="bi bi-file-earmark-pdf-fill text-danger fs-3"></i>
              <a :href="`${BASE_URL}uploads/${form.roiReportPath}`" target="_blank" class="flex-grow-1 text-decoration-none">
                {{ form.roiReportName || 'ملف تقرير العائد الاستثماري' }}
              </a>
              <loader v-if="roiDeleting" />
              <button v-else type="button" class="btn btn-outline-danger btn-sm" @click="deleteRoiReport">
                <i class="bi bi-trash"></i> حذف
              </button>
            </div>
            <div v-else>
              <label class="form-label">رفع ملف PDF لتقرير العائد الاستثماري</label>
              <input type="file" accept="application/pdf" class="form-control" @change="onRoiFileChange" />
              <div v-if="roiUploading" class="mt-2"><loader /> جاري الرفع...</div>
              <errorAlert v-if="roiError" :alertMessage="roiErrorMessage" />
            </div>
          </div>
        </div>

        <PropertyProfile :propertyId="propertyId" />

        <div class="row py-2">
          <div class="col text-center">
            <loader v-if="saving" />
            <button v-else type="submit" class="btn btn-success px-5">
              <i class="bi bi-save me-1"></i> حفظ البيانات الإضافية
            </button>
          </div>
        </div>

      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PropertyProfile from './PropertyProfile.vue';

const EMPTY_FORM = () => ({
  waterSeparation: null,
  waterAccountNumber: '',
  waterMeterNumber: '',
  electricityAccountNumber: '',
  electricityTenantMeterAccount: '',
  electricityMeterNumber: '',
  electricityMeterSubscription: '',
  garageCount: null,
  garageRemoteCount: null,
  acCount: null,
  acRemoteCount: null,
  kitchenCount: null,
  heaterCount: null,
  regaContractNumber: '',
  regaContractRenewalDate: '',
  billboardNumber: '',
  electricityMeterLocationNumber: '',
  acType: '',
  roiReportPath: '',
  roiReportName: '',
  managementContractRenewalDate: '',
  guardNumber: '',
  projectManagerId: null,
});

export default {
  name: 'PropertyAdditionals',
  components: { PropertyProfile },
  props: {
    propertyId: { type: [Number, String], required: true },
  },
  data() {
    return {
      loading: true,
      saving: false,
      success: false,
      error: false,
      errorMessage: '',
      form: EMPTY_FORM(),
      roiUploading: false,
      roiDeleting: false,
      roiError: false,
      roiErrorMessage: '',
      approvalManagers: [],
    };
  },
  computed: {
    ...mapGetters(['BASE_URL']),
  },
  methods: {
    load() {
      this.loading = true;
      this.$http.get(`/api/admin/properties/${this.propertyId}/additionals`)
        .then(({ data }) => {
          this.approvalManagers = data.approvalManagers || [];
          if (data.additionals) {
            const a = data.additionals;
            this.form = {
              waterSeparation: a.waterSeparation ?? null,
              waterAccountNumber: a.waterAccountNumber ?? '',
              waterMeterNumber: a.waterMeterNumber ?? '',
              electricityAccountNumber: a.electricityAccountNumber ?? '',
              electricityTenantMeterAccount: a.electricityTenantMeterAccount ?? '',
              electricityMeterNumber: a.electricityMeterNumber ?? '',
              electricityMeterSubscription: a.electricityMeterSubscription ?? '',
              garageCount: a.garageCount ?? null,
              garageRemoteCount: a.garageRemoteCount ?? null,
              acCount: a.acCount ?? null,
              acRemoteCount: a.acRemoteCount ?? null,
              kitchenCount: a.kitchenCount ?? null,
              heaterCount: a.heaterCount ?? null,
              regaContractNumber: a.regaContractNumber ?? '',
              regaContractRenewalDate: a.regaContractRenewalDate ?? '',
              billboardNumber: a.billboardNumber ?? '',
              electricityMeterLocationNumber: a.electricityMeterLocationNumber ?? '',
              acType: a.acType ?? '',
              roiReportPath: a.roiReportPath ?? '',
              roiReportName: a.roiReportName ?? '',
              managementContractRenewalDate: a.managementContractRenewalDate ?? '',
              guardNumber: a.guardNumber ?? '',
              projectManagerId: a.projectManagerId ?? null,
            };
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    save() {
      this.saving = true;
      this.success = false;
      this.error = false;
      this.$http.put(`/api/admin/properties/${this.propertyId}/additionals`, this.form)
        .then(() => {
          this.saving = false;
          this.success = true;
          window.scroll(0, 0);
        })
        .catch(err => {
          this.saving = false;
          this.error = true;
          this.errorMessage = this.$globalError(err);
          window.scroll(0, 0);
        });
    },
    onRoiFileChange(e) {
      const file = e.target.files[0];
      if (!file) return;
      if (file.type !== 'application/pdf') {
        this.roiError = true;
        this.roiErrorMessage = 'يجب أن يكون الملف بصيغة PDF';
        e.target.value = '';
        return;
      }
      this.uploadRoiReport(file);
      e.target.value = '';
    },
    uploadRoiReport(file) {
      this.roiUploading = true;
      this.roiError = false;
      const formData = new FormData();
      formData.append('file', file);
      formData.append('name', file.name);
      this.$http.put(`/api/admin/properties/${this.propertyId}/additionals/roiReport`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
        .then(({ data }) => {
          this.roiUploading = false;
          this.form.roiReportPath = data.additionals.roiReportPath;
          this.form.roiReportName = data.additionals.roiReportName;
        })
        .catch(err => {
          this.roiUploading = false;
          this.roiError = true;
          this.roiErrorMessage = this.$globalError(err);
        });
    },
    deleteRoiReport() {
      this.roiDeleting = true;
      this.$http.delete(`/api/admin/properties/${this.propertyId}/additionals/roiReport`)
        .then(() => {
          this.roiDeleting = false;
          this.form.roiReportPath = '';
          this.form.roiReportName = '';
        })
        .catch(err => {
          this.roiDeleting = false;
          this.roiError = true;
          this.roiErrorMessage = this.$globalError(err);
        });
    },
  },
  created() {
    this.load();
  },
};
</script>